export default __webpack_public_path__ + "static/media/ImgGift06.c7acd9aa.jpg";